import { render, staticRenderFns } from "./NoteCard.vue?vue&type=template&id=d5b4e1da&scoped=true&"
import script from "./NoteCard.vue?vue&type=script&lang=ts&"
export * from "./NoteCard.vue?vue&type=script&lang=ts&"
import style0 from "./NoteCard.vue?vue&type=style&index=0&id=d5b4e1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b4e1da",
  null
  
)

export default component.exports